// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import { faRulerHorizontal, faRulerVertical, faRuler } from '@fortawesome/free-solid-svg-icons';

library.add(
    faRulerHorizontal,
    faRulerVertical,
    faRuler
  // more icons go here
);
